import { TelevisionBoxIcon } from './TelevisionBoxIcon';

/**
 * author: Google
 * id CB446614-AE63-403E-BBF8-0B0ED3E367AE
 * name television-box
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television-box.svg
 * tags
 */
export const TvGuideIcon = TelevisionBoxIcon;
export default TvGuideIcon